'use strict';

function deferred(fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
}

module.exports = deferred;



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/wrap-promise/lib/deferred.js
// module id = 646
// module chunks = 0